import { render } from "./EnbItemBtn01.vue?vue&type=template&id=5f116ca0&scoped=true"
import script from "./EnbItemBtn01.vue?vue&type=script&lang=js"
export * from "./EnbItemBtn01.vue?vue&type=script&lang=js"

import "./EnbItemBtn01.vue?vue&type=style&index=0&id=5f116ca0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f116ca0"]])

export default __exports__